import { useState } from "react";
import { sendContactMessage } from "../api/contactApi";

export default function ContactPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setError("");
    setSuccess(false);

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess(false);

    try {
      setLoading(true);

      await sendContactMessage({
        name: form.name.trim(),
        email: form.email.trim(),
        subject: form.subject.trim(),
        message: form.message.trim(),
      });

      setSuccess(true);

      setForm({
        name: "",
        email: "",
        subject: "",
        message: "",
      });

      setTimeout(() => {
        setSuccess(false);
      }, 4000);
    } catch (err) {
      setError(err.message || "خطا در ارسال پیام");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      <section className="page-hero glass-card">
        <span className="hero-badge">ارتباط با ما</span>

        <h2>تماس با مجموعه چشم هوشمند آموزش</h2>

        <p>
          برای دریافت مشاوره، پشتیبانی، همکاری یا ثبت پیشنهادات و انتقادات، می‌توانید
          از طریق فرم زیر با ما در ارتباط باشید.
        </p>
      </section>

      <section className="contact-wrapper">
        <div className="contact-info glass-card">
          <h2>اطلاعات تماس</h2>

          <div className="contact-item">
            <span>📞 تلفن</span>
            <p>02191313513</p>
            <p>09120381360</p>
          </div>

          <div className="contact-item">
            <span>📧 ایمیل</span>
            <p>info@iemict.com</p>
            <p>iemict@iran.ir</p>
          </div>

          <div className="contact-item">
            <span>📍 آدرس</span>
            <span>
              شعبه تهران: چهارراه فرمانیه، ابتدای نارنجستان هفتم، پلاک 44،
              مجتمع اداری تجاری A1 فرمانیه
            </span>
            <span>
              دفتر مرکزی: کرج، چهار راه کارخانه قند، خیابان زکریا رازی،
              مجتمع اداری مشتاق، واحد 11
            </span>
          </div>

          <div className="contact-item">
            <span>🕒 ساعات پاسخگویی</span>
            <p>شنبه تا چهارشنبه - 8 تا 17</p>
          </div>
        </div>

        <form className="contact-form glass-card" onSubmit={handleSubmit}>
          <h2>ارسال پیام</h2>

          {success && (
            <div className="auth-success">
              پیام شما با موفقیت ارسال شد.
            </div>
          )}

          {error && (
            <div className="auth-error">
              {error}
            </div>
          )}

          <div className="contact-grid">
            <div className="contact-field">
              <label>نام و نام خانوادگی</label>

              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="contact-field">
              <label>ایمیل</label>

              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                dir="ltr"
              />
            </div>

            <div className="contact-field contact-full">
              <label>موضوع</label>

              <input
                type="text"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="contact-field contact-full">
              <label>متن پیام</label>

              <textarea
                name="message"
                rows="7"
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "در حال ارسال..." : "ارسال پیام"}
          </button>
        </form>
      </section>

      <section className="map-box glass-card">
        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3235.6578955366467!2d50.98673147623553!3d35.80833102298084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8dbf007e64d8e7%3A0xd6e10ccad4a80ce4!2z2LTYsdqp2Kog2obYtNmFINmH2YjYtNmF2YbYryDZhdin2LTbjNmG!5e0!3m2!1sen!2sus!4v1778503474250!5m2!1sen!2sus"
          loading="lazy"
        />
      </section>
    </div>
  );
}
